import { create } from 'zustand';
import type { Message } from '../types/chat';

interface ConversationStore {
  sessionMessages: Message[];
  addToContext: (message: Message) => void;
  getFormattedContext: () => string;
  clearContext: () => void;
}

export const useConversationContext = create<ConversationStore>((set, get) => ({
  sessionMessages: [],
  
  addToContext: (message) => {
    set((state) => ({
      sessionMessages: [...state.sessionMessages, message]
    }));
  },

  getFormattedContext: () => {
    const { sessionMessages } = get();
    if (sessionMessages.length === 0) return '';

    return sessionMessages
      .map(msg => `${msg.type === 'user' ? 'Utilisateur' : 'Assistant'}: ${msg.content}`)
      .join('\n');
  },

  clearContext: () => {
    set({ sessionMessages: [] });
  }
}));